import { Component, OnInit, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';

import { InjectionPressureDataRecord } from '../_models/injection-pressure-data-record';
import { BHPService } from '../_services/bhp.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { WellDetailsModel } from '../_models/well-details-model';
import { NgDynamicBreadcrumbService } from 'ng-dynamic-breadcrumb';
import { UserWellsService } from '../user-wells.service';
import { MatDialog } from '@angular/material/dialog';
import { ApiResultErrorDialogComponent } from '../api-result-error-dialog/api-result-error-dialog.component';

@Component({
  selector: 'app-injection-pressure-record-editor',
  templateUrl: './injection-pressure-record-editor.component.html',
  styleUrls: ['./injection-pressure-record-editor.component.css']
})
export class InjectionPressureRecordEditorComponent implements OnInit {

  injectionPressureId: number;

  injectionPressureDetailsSubscription: Subscription;
  wellDetailsSubscription: Subscription;

  injectionPressureDetails: InjectionPressureDataRecord = new InjectionPressureDataRecord();

  wellDetails: WellDetailsModel = null;

  mainFormGroup: FormGroup;
  injectionId: number;
  wellId: number;

  constructor(
    private actRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private bhpService: BHPService,
    public userWellsService: UserWellsService,
    protected router: Router,
    protected breadcrumbService: NgDynamicBreadcrumbService,
    protected dialog: MatDialog
  ) {
    this.injectionPressureId = this.actRoute.snapshot.params.injectionPressureId;
    this.wellId = this.actRoute.snapshot.params.wellId;

    this.refreshForm();
  }

  ngOnInit(): void {
    
  }

  ngAfterViewInit(): void {
    this.bhpService.GetRecord(this.injectionPressureId).then((result: InjectionPressureDataRecord) => {
      if(result != null) {
        this.injectionPressureDetails = result;

        this.userWellsService.LoadDetailsWell(this.injectionPressureDetails.WellId);

        var injDate = this.injectionPressureDetails.MeasurementDate;

        function formatDate(date) {
          var d = new Date(date),
              month = '' + (d.getMonth() + 1),
              day = '' + d.getDate(),
              year = d.getFullYear();

          if (month.length < 2) 
              month = '0' + month;
          if (day.length < 2) 
              day = '0' + day;

          return [year, month, day].join('-');
        }

        var breadcrumbdata = {
          MeasurementDate: formatDate(injDate)
        };

        this.breadcrumbService.updateBreadcrumbLabels(breadcrumbdata);

        this.mainFormGroup.patchValue(this.injectionPressureDetails);
      }
    },
    (err) => {
      //Handle an error where the injection details record didn't load for some reason.
    });

    //Subscribe to the well details service
    this.wellDetailsSubscription = this.userWellsService.detailsWell.subscribe((result: WellDetailsModel) => {
      this.wellDetails = result;

      var breadcrumbdata = {
        Uicnumber: this.wellDetails.Uicnumber.toString()
      };

      this.breadcrumbService.updateBreadcrumbLabels(breadcrumbdata);
    });
  }

  save() {

    var injPressureModel = this.mainFormGroup.value;

    this.bhpService.UpdateRecord(injPressureModel).then((result) => {

      if (result.Success) {

        var destinationUrl = "well/" + this.wellId;

        this.router.navigateByUrl(destinationUrl);
      }
      else {
        var dialogRef = this.dialog.open(ApiResultErrorDialogComponent, {
          data: result
        });
      }
    },
      (result) => {
        var dialogRef = this.dialog.open(ApiResultErrorDialogComponent, {
          data: result
        });
    });
  }

  refreshForm() {

    function otherDataValidator() {
      return (group: FormGroup): { [key: string]: any } => {
        let ret: any = {};

        let shutinPressures = [];

        if(group.controls.ShutinBHPDaily.value != '' && group.controls.ShutinBHPDaily.value) {
          shutinPressures.push(group.controls.ShutinBHPDaily.value);
        }

        if(group.controls.ShutinBHPQuarterlyCalc.value != '' && group.controls.ShutinBHPQuarterlyCalc.value) {
          shutinPressures.push(group.controls.ShutinBHPQuarterlyCalc.value);
        }

        if(group.controls.ShutinBHPQuarterlyMeas.value != '' && group.controls.ShutinBHPQuarterlyMeas.value) {
          shutinPressures.push(group.controls.ShutinBHPQuarterlyMeas.value);
        }

        if(shutinPressures.length > 1) {
          ret.tooManyShutinPressures = true;
        }

        if(shutinPressures.length == 0) {
          ret.noShutinPressure = true;
        }

        return ret;
      }
    }

    this.mainFormGroup = this.formBuilder.group({
      'Id': [this.injectionPressureDetails.Id, []],
      'WellId': [this.injectionPressureDetails.WellId, []],
      'MeasurementDate': [this.injectionPressureDetails.MeasurementDate, []],
      'ShutinBHPDaily': [this.injectionPressureDetails.ShutinBHPDaily, [Validators.min(0), Validators.max(99999.9)]],
      'ShutinBHPQuarterlyCalc': [this.injectionPressureDetails.ShutinBHPQuarterlyCalc, [Validators.min(0), Validators.max(99999.9)]],
      'ShutinBHPQuarterlyMeas': [this.injectionPressureDetails.ShutinBHPQuarterlyMeas, [Validators.min(0), Validators.max(99999.9)]],
      'TvdDepBHPSensor': [this.injectionPressureDetails.TvdDepBHPSensor, [Validators.min(0), Validators.max(30000)]],
      'MeaDayInjLiqDens': [this.injectionPressureDetails.MeaDayInjLiqDens, [Validators.min(5), Validators.max(20)]],
      'StaticDayMeasSurfPress': [this.injectionPressureDetails.StaticDayMeasSurfPress, [Validators.min(0), Validators.max(99999.9)]],
      'ShutinTimeForStaticPress': [this.injectionPressureDetails.ShutinTimeForStaticPress, [Validators.min(0), Validators.max(100000)]],
      'AveDayMeasBHP': [this.injectionPressureDetails.AveDayMeasBHP, [Validators.min(0), Validators.max(99999.9)]],
      'MaxDayMeasBHP': [this.injectionPressureDetails.MaxDayMeasBHP, [Validators.min(0), Validators.max(99999.9)]],
      'AveDayEstBHP': [this.injectionPressureDetails.AveDayEstBHP, [Validators.min(0), Validators.max(99999.9)]],
      'MaxDayEstBHP': [this.injectionPressureDetails.MaxDayEstBHP, [Validators.min(0), Validators.max(99999.9)]]
    },
    {
      validator: otherDataValidator()
    });

  }

   public findInvalidControls() {
        const invalid = [];
        const controls = this.mainFormGroup.controls;
        for (const name in controls) {
            if (controls[name].invalid) {
                invalid.push(name);
            }
        }
        return invalid;
    }

}
